import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import { mapGetters } from 'vuex';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtGetProduct, rqtPostProductExtra } from '@/services/wms/product';
import { rqtGetListForSelect } from '@/services/ams/partner';
import { rqtGetProductManagerListForSelect } from '@/services/ams/user-privilege';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt
  },
  data() {
    return {
      production: {},
      productExtra: {},
      codeResItems: [{
        title: '产品子类型',
        dataIndex: 'productSubType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'productSubType'
      }, {
        title: '产品子类型',
        dataIndex: 'productType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'productType'
      }, {
        title: '销售状态',
        dataIndex: 'salesStatus',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'salesStatus'
      }, {
        title: '产品形态',
        dataIndex: 'productForm',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'productForm'
      }, {
        title: '募集机构',
        dataIndex: 'raisedOrganization',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'raisedOrganization'
      }, {
        title: '产品类别',
        dataIndex: 'wealthCategory',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'wealthCategory'
      }, {
        title: '风险等级',
        dataIndex: 'riskGrade',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'riskGrade'
      }, {
        title: '分配方式',
        dataIndex: 'distributionMethod',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'distributionMethod'
      }, {
        title: '适合投资人类型',
        dataIndex: 'custRiskLevel',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'custRiskLevel'
      }, {
        title: '封闭期单位',
        dataIndex: 'closePeriodUnit',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'closePeriodUnit'
      }, {
        title: '产品状态',
        dataIndex: 'productStatus',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'productStatus'
      }],
      otherResItems: [{
        title: '合作机构',
        dataIndex: 'partnerId',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'partnerId',
          title: 'partnerName'
        },
        req: rqtGetListForSelect
      }, {
        title: '产品经理',
        dataIndex: 'productManagerId',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'id',
          title: 'userName'
        },
        req: rqtGetProductManagerListForSelect
      }]
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  mounted() {
    let productId = this.$route.params.productId;
    if (productId) {
      this.initResCodeType(this.codeResItems);
      for (const item of this.otherResItems) {
        item.req().then(res => {
          item.dataRes = res.data.data;
        });
      }
      this.init(productId);
    }
  },
  methods: {
    init(productId) {
      rqtGetProduct(productId).then(res => {
        this.production = res.data.data;
      });
      rqtPostProductExtra(productId).then(res => {
        this.productExtra = res.data.data.productExtra;
        if (this.productExtra.custRiskLevel) {
          let custRiskLevelItem = this.codeResItems.find(e => e.dataIndex === "custRiskLevel");
          console.log(custRiskLevelItem);
          let custRiskLevelValue = "";
          for (let key of this.productExtra.custRiskLevel.split(",")) {
            if (key) {
              custRiskLevelValue += custRiskLevelItem.dataRes.find(e => e.code === key).codeName + ",";
            }
          }
          this.productExtra.custRiskLevelValue = custRiskLevelValue.slice(0, -1);
        }
      });
    }
  }
};